module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/search-3c7f72df3d97acf464aa9f65d7019627.svg";